import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Container, View } from '@amzn/stencil-react-components/layout';
import { Row } from '@amzn/stencil-react-components/layout';
import { Spacer } from '@amzn/stencil-react-components/layout';

import { Text } from '@amzn/stencil-react-components/text';

class FooterContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const footerWidth = document.body.offsetWidth + 16;
    return (
      <Container isFullWidth={true}>
        <View
          backgroundColor="neutral90"
          color={'#fff'}
          padding={'10px'}
          margin={'0px 0px -12px -8px'}
        >
          <Row gridGap="S500" padding={10}>
            <Text>Copyright</Text>
            <Spacer flex={1} />
            <Text>Nudge Engine @HR 2021</Text>
          </Row>
        </View>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  nudge: { ...state.nudge },
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FooterContainer);
